import {  Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomComposedChart, { GrUsageChart } from "./ComposedChart";

const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    padding: "20px",
    width: "100%",
    "@media print": {
      height: "90mm",
      breakInside: "avoid",
      colorAdjust: "exact",
      pageBreakBefore: "avoid",
      pageBreakAfter: "always",
    },
  },
  header: {
    padding: "30px",
    fontWeight: "bold",
    fontSize: "16px",
  },
};

interface IProps {
  chartData: GrUsageChart[];
}

const BooksStatistic = ({ chartData }: IProps) => {

  const { t } = useTranslation();

  const dataKeys = [
    {
      label: t("Books Read"),
      color: "rgb(67, 189, 189)",
      legendColor: "rgb(67, 189, 189)",
    },
    {
      label: t("No Of Student"),
      color: "rgba(174, 24, 67, 0.9)",
      legendColor: "rgba(174, 24, 67, 0.9)",
    },
  ];

  return (
    <Typography component="div" sx={customStyles.root}>
      <Typography component="h1" sx={customStyles.header}>
        {t("Number Of Books Read Each Month")}
      </Typography>
        <CustomComposedChart
          data={chartData}
          dataKeys={dataKeys}
          xAxisLabel={"xAxisLabel"}
        />
    </Typography>
  );
};

export default BooksStatistic;
